import HolidayHome from "@/Component/Module/HolidayHome";
import SeoHead from "@/Component/Seo/SeoHead";
import {
  serverFetchCouponList,
  serverFetchFeaturedJourneys,
  serverFetchHolidaysBreaks,
  serverFetchSeasonalDeals,
} from "@/services/server";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import { fetchPageSeo } from "@/utils/pageSeo";

export default function Home({
  seo,
  seoCountry,
  initialFeaturedJourney,
  initialCouponList,
  initialSeasonalDeals,
  initialHolidaysBreaks,
}) {
  return (
    <>
      <SeoHead
        seo={seo}
        country={seoCountry}
        fallbackTitle="Next Holidays | Your Next Journey Begins Here"
      />
      <HolidayHome
        data={{
          initialFeaturedJourney,
          initialCouponList,
          initialSeasonalDeals,
          initialHolidaysBreaks,
        }}
      />
    </>
  );
}

export async function getServerSideProps(context) {
  const country = getCountryFromContext(context);
  const seoResult = await fetchPageSeo(context, { ignoreRedirect: true });
  if (seoResult.redirect) return seoResult;

  try {
    const [
      featuredJourneys,
      couponList,
      seasonalDeals,
      visaFreeBreaks,
      visaOnArrivalBreaks,
      eVisaBreaks,
    ] = await Promise.all([
      serverFetchFeaturedJourneys(country),
      serverFetchCouponList(country),
      serverFetchSeasonalDeals(country),
      serverFetchHolidaysBreaks(1, country),
      serverFetchHolidaysBreaks(2, country),
      serverFetchHolidaysBreaks(3, country),
    ]);

    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        initialFeaturedJourney: featuredJourneys?.data || null,
        initialCouponList: couponList?.data || null,
        initialSeasonalDeals: Array.isArray(seasonalDeals?.data)
          ? seasonalDeals.data
          : [],
        initialHolidaysBreaks: {
          1: Array.isArray(visaFreeBreaks?.data) ? visaFreeBreaks.data : [],
          2: Array.isArray(visaOnArrivalBreaks?.data) ? visaOnArrivalBreaks.data : [],
          3: Array.isArray(eVisaBreaks?.data) ? eVisaBreaks.data : [],
        },
      },
    };
  } catch {
    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        initialFeaturedJourney: null,
        initialCouponList: null,
        initialSeasonalDeals: [],
        initialHolidaysBreaks: { 1: [], 2: [], 3: [] },
      },
    };
  }
}
